import axios from "axios";
import { BACKEND_SERVER_URL } from "../constants/api.constant";

const api = axios.create({
  baseURL: `${BACKEND_SERVER_URL}`,
});

export default api;